import {SListTabs} from "shj-components";
import Exception from "@/pages/clueManage/exception/exception.tsx";
import Collision from "@/pages/clueManage/collision/collision.tsx";
import KeepAlive from "react-activation";

const ErrorList = () => {
  const items = [
    {
      key: 'exception',
      label: '派单异常',
      children: <Exception />,
    },
    {
      key: 'collision',
      label: '撞单异常',
      children: <Collision />,
    },
  ]
  return <SListTabs auth={true} items={items}/>
}

export default function ErrorListPage() {
  return (
    <KeepAlive name={location.pathname}>
      <div>
        <ErrorList />
      </div>
    </KeepAlive>
  )
}